"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var colors = _interopRequireWildcard(require("../../style/colors"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Svg = _styledComponents["default"].svg.withConfig({
  displayName: "Svg",
  componentId: "sc-199sdzc-0"
})(["", ""], function (_ref) {
  var rotate = _ref.rotate;
  return "transform: rotate(".concat(rotate, "deg)");
});

var InfoIcon = function InfoIcon(_ref2) {
  var height = _ref2.height,
      width = _ref2.width,
      stroke = _ref2.stroke,
      rotate = _ref2.rotate;
  return _react["default"].createElement(Svg, {
    rotate: rotate,
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "M7 14c-3.8659932 0-7-3.1340068-7-7s3.1340068-7 7-7 7 3.1340068 7 7-3.1340068 7-7 7zM7 4c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1 1-.4477153 1-1-.4477153-1-1-1zm0 3c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1V8c0-.5522847-.4477153-1-1-1z",
    fill: stroke,
    fillRule: "evenodd"
  }));
};

InfoIcon.propTypes = {
  width: _propTypes.PropTypes.string,
  height: _propTypes.PropTypes.string,
  stroke: _propTypes.PropTypes.string,
  rotate: _propTypes.PropTypes.number
};
InfoIcon.defaultProps = {
  width: '14px',
  height: '14px',
  stroke: colors.primary,
  rotate: 0
};
var _default = InfoIcon;
exports["default"] = _default;